import React, { useEffect, useState, useRef } from "react";
import {
  Alert as MuiAlert,
  Box,
  Grid,
  DialogActions,
  Button,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import { spacing } from "@mui/system";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import ReplayIcon from "@mui/icons-material/Replay";
import { useDispatch } from "react-redux";

import { useDialog } from "../../../../contexts/DialogContext";
import useUser from "../../../../hooks/useUser";
import CustomTextField from "../../../../components/CustomTextField";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";

const Alert = styled(MuiAlert)(spacing);

const validationSchema = Yup.object().shape({
  dataLimit: Yup.number()
    .typeError("Must be a number") // Custom error message for non-numeric values
    .required("Required"),
  size: Yup.string().required("Required"),
});

const UpdateDataLimit = (props) => {
  const dispatch = useDispatch();
  const { isRenewSubmitting, updateDataLimit } = useUser();
  const { userId, refreshPage } = props;

  const methods = useForm({
    defaultValues: {
      dataLimit: "",
      size: "mb",
    },
    resolver: yupResolver(validationSchema),
  });
  const {
    reset,
    handleSubmit,
    watch,
    resetField,
    formState: { errors },
    control,
  } = methods;
  const { unSetDialog, openDialog } = useDialog();

  const { t } = useTranslation();

  const onSubmit = async (data) => {
    try {
      const payload = {
        radUserId: userId,
        dataLimit: data.dataLimit,
        size: data.size,
      };
      await updateDataLimit(payload);
      dispatch(showSuccessSnackbar("Data limit updated successfully!"));
      if (typeof refreshPage === "function") {
        refreshPage();
      }
      unSetDialog("update_data");
    } catch (ex) {
      dispatch(showErrorSnackbar(ex.message));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
              <CustomTextField
                label={t("update_data_limit")}
                name="dataLimit"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationSchema.fields}
              />
            </Grid>
            <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
              <ReactHookFormSelect
                name="size"
                label={t("size")}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationSchema.fields}
              >
                <MenuItem value={"bytes"}>Bytes</MenuItem>
                <MenuItem value={"kb"}>KB</MenuItem>
                <MenuItem value={"mb"}>MB</MenuItem>
                <MenuItem value={"gb"}>GB</MenuItem>
              </ReactHookFormSelect>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<ReplayIcon />}
              endIcon={isRenewSubmitting ? <CircularProgress size={24} /> : null}
              disabled={false}
            >
              Save
            </Button>

            <Button variant="text" onClick={() => unSetDialog("update_data")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default UpdateDataLimit;
